import Loader from '../../components/loader/Loader';
import './EmptyPage.css';

export default function EmptyPage()
{
    return(
        <div className='PageComponent'>
            <Loader />
        </div>
    )
}